const t = "pk_test_O3PjYFYA7hqkDM12lU32xgRT";
export {
  t as STRIPE_KEY_DEV
};
